module.exports = __webpack_public_path__ + "static/media/27OCHA6.5a9eaf78.jpg";